import React from 'react';
import I18n from 'i18n-js';
import qs from 'qs';

import CsrfForm from '../csrf_form';
import { FACEBOOK_AUTH_PATH } from '../url_helpers';
import FacebookIcon from '../../design-system/icons/core/facebook.svg?component';
import { RCTextWithIcon } from '../rc/RCTextWithIcon';
import { RCButton } from '../rc/RCButton';

interface Props {
  redirectTo?: string;
  isSignup?: boolean;
  isExperimentEnabled?: boolean;
}

export default function FacebookSigninButton(props: Props) {
  const query = qs.stringify({ redirect_to: props.redirectTo });
  const id = 'facebook-signup-signin';

  const title = props.isSignup
    ? I18n.t('commons.signupForm.facebookSignup')
    : I18n.t('commons.signupForm.facebookSignin');

  return (
    <CsrfForm
      id={id}
      method="post"
      action={`${FACEBOOK_AUTH_PATH}?${query}`}
    >
      <input type="hidden" name="name" value="value" />
      { props.isExperimentEnabled ?
        <div className="signup-signin__form__facebook__button">
          <RCButton
            isSubmit
            form={id}
          >
            <RCTextWithIcon svgComponent={FacebookIcon} placement="left">
              {title}
            </RCTextWithIcon>
          </RCButton>
        </div>
        :
        <div className="signup-signin__form__facebook">
          <button
            type="submit"
            form={id}
            className="signup-signin__form__facebook__link"
          >
            {title}
          </button>
        </div>
      }
    </CsrfForm>
  );
}
